import { IMAGES } from 'configs/configs.js'

export const Icon = (icon: string) => `${IMAGES.URL}/icons/${icon}`
